import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useThemeMode } from '../../ThemeContext';

// Import mobile screenshots
import Mobile1 from '../../assets/landing_page_images/mobile1.jpg';
import Mobile2 from '../../assets/landing_page_images/mobile2.jpg';
import Mobile3 from '../../assets/landing_page_images/mobile3.jpg';
import Mobile4 from '../../assets/landing_page_images/mobile4.jpg';

function MobileApps() {
  const { mode } = useThemeMode();
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const mobileScreenshots = [Mobile1, Mobile2, Mobile3, Mobile4];
  
  // Group screenshots into pairs (2 images per slide)
  const slides = [];
  for (let i = 0; i < mobileScreenshots.length; i += 2) {
    slides.push(mobileScreenshots.slice(i, i + 2));
  }
  
  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000); // Change slide every 4 seconds
    
    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <>
      {/* Mobile Apps Section */}
      <section className="mobile-apps-section py-5">
        <Container>
          <div className="text-center mb-5">
            <div className="mobile-apps-section-title">Take Compliance On The Go</div>
          </div>
          <Row className="align-items-center">
            <Col xs={12} lg={6} className="mb-5 mb-lg-0">
              <div className="mobile-apps-content">
                <div className="mobile-apps-subtitle">
                  Access Complimate anywhere, anytime with our mobile apps. Manage documents, run audits, track tasks, and get instant compliance answers all from your Android or iOS device.
                </div>
                <div className="mobile-apps-features">
                  <div className="mobile-apps-feature-item">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 16L14 12L10 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Full access to all compliance features</span>
                  </div>
                  <div className="mobile-apps-feature-item">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 16L14 12L10 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Offline access to your documents</span>
                  </div>
                  <div className="mobile-apps-feature-item">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 16L14 12L10 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Photo audits and evidence capture</span>
                  </div>
                  <div className="mobile-apps-feature-item">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 16L14 12L10 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Real-time sync across all devices</span>
                  </div>
                </div>
                <div className="mobile-apps-buttons">
                  <a 
                    href="https://play.google.com/store/apps/details?id=com.complimate" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="store-button store-button-google"
                    aria-label="Download on Google Play"
                  >
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="store-icon">
                      <path d="M3 20.5V3.5C3 2.91 3.34 2.39 3.84 2.15L13.69 12L3.84 21.85C3.34 21.6 3 21.09 3 20.5ZM16.81 15.12L6.05 21.34L14.54 12.85L16.81 15.12ZM20.16 10.81C20.5 11.08 20.75 11.5 20.75 12C20.75 12.5 20.53 12.9 20.18 13.18L17.89 14.5L15.39 12L17.89 9.5L20.16 10.81ZM6.05 2.66L16.81 8.88L14.54 11.15L6.05 2.66Z" fill="currentColor"/>
                    </svg>
                    <div className="store-button-text">
                      <div className="store-button-label">GET IT ON</div>
                      <div className="store-button-name">Google Play</div>
                    </div>
                  </a>
                  <a 
                    href="https://apps.apple.com/us/app/complimate-app/id6756040647" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="store-button store-button-apple"
                    aria-label="Download on App Store"
                  >
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="store-icon">
                      <path d="M17.05 20.28C16.07 21.28 14.87 21.05 13.66 20.65C12.43 20.24 11.27 20.22 9.97 20.65C8.5 21.13 7.57 20.86 6.68 19.9C2.78 15.79 3.51 9.21 7.82 8.94C9.1 9.03 9.93 9.65 10.9 9.72C12.08 9.84 13.22 9.18 14.5 9.11C15.93 9.03 17.25 9.5 18.11 10.45C15.17 12.18 15.84 16.09 18.58 17.2C18.01 18.7 17.23 20.19 17.05 20.28ZM12.03 8.88C11.82 6.54 13.82 4.53 15.97 4.25C16.2 6.96 13.38 9.1 12.03 8.88Z" fill="currentColor"/>
                    </svg>
                    <div className="store-button-text">
                      <div className="store-button-label">Download on the</div>
                      <div className="store-button-name">App Store</div>
                    </div>
                  </a>
                </div>
              </div>
            </Col>
            <Col xs={12} lg={6}>
              <div className="mobile-apps-screenshots">
                <div className="mobile-screenshot-slider">
                  <div className="slider-container">
                    <div 
                      className="slider-track" 
                      style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                    >
                      {slides.map((slide, slideIndex) => (
                        <div key={slideIndex} className="slider-slide">
                          {slide.map((image, imageIndex) => (
                            <div key={imageIndex} className="mobile-screenshot-item">
                              <img 
                                src={image} 
                                alt={`Complimate Mobile App Screenshot ${slideIndex * 2 + imageIndex + 1}`} 
                                className="mobile-screenshot-img" 
                              />
                            </div>
                          ))}
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  <div className="slider-dots">
                    {slides.map((_, index) => (
                      <button
                        key={index}
                        className={`slider-dot ${index === currentSlide ? 'active' : ''}`}
                        onClick={() => setCurrentSlide(index)}
                        aria-label={`Go to slide ${index + 1}`}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default MobileApps;

